import React, { useEffect } from 'react';
import { Form, Input, Table, Tag } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { renderNum } from '@/utils/common';
import { getConsumerGroupList } from '@/services/kopConsumerGroupService';
import useTable from '@/hooks/useTable';
import PopupLink from '@/components/Cluster/PopupLink';

const { FormItem } = Form;

export default function ConsumerGroups({ commonProps }) {
  const navigate = useNavigate();

  const columns = [
    {
      colKey: 'consumerGroupName',
      title: 'ConsumerGroup',
      width: 200,
      fixed: 'left',
    },
    {
      colKey: 'consumedTopicName',
      title: '消费的Topic',
      cell: ({ row }) =>
        row.consumedTopicName?.split(',').map((item, index) => (
          <div key={index}>
            <Tag style={{ margin: '2px 0' }}>
              <PopupLink
                style={{ display: 'block' }}
                tip='跳转Topic'
                onClick={() => {
                  navigate(
                    `/kop-cluster/consumer-group/list?name=${commonProps.clusterName}&topic=${item}`,
                  );
                }}
              >
                {item}
              </PopupLink>
            </Tag>
          </div>
        )),
    },
    {
      colKey: 'status',
      title: 'Status',
      width: 100,
    },
    {
      colKey: 'maxLag',
      title: 'Max Lag',
      cell: renderNum,
      width: 160,
    },
    {
      colKey: 'memberSize',
      title: 'Member数',
      cell: renderNum,
      width: 160,
    },
  ];

  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getConsumerGroupList({
      ...commonProps,
      ...params,
    });
    setData(data);
  });

  const { config, header, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        <FormItem name='consumerGroupName'>
          <Input placeholder='请输入ConsumerGroup' />
        </FormItem>
      </>
    ),
  });

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 18px;
`;
